

import {Component, Vue} from "vue-property-decorator"
import {IAppletBanner} from "@/apis/applet/banner/types"
import config from "@/config";
import type {ICrudOption} from "@/types/m-ui-crud"
import {IPage} from "@/apis/page";
import {fruitTreeCreateApi, fruitTreeDetailApi, fruitTreeModifyApi, fruitTreeQueryApi} from "@/apis/linye";

@Component({})
export default class FruitTree extends Vue {
  config = config
  // 表格加载状态
  tableLoading: boolean = true;
  // 表格数据
  tableData: any[] = []
  // 表格总数
  tableTotal = 0
  // 查询参数
  queryParam: IPage = {
    page: 1,
    limit: 10
  }
  // 表单参数
  modelForm: Partial<any> = {}
  // crud配置信息
  crudOption: ICrudOption = {
    delBtn: false,
    searchBox: true,
    dialogWidth: '70%',
    labelWidth: '150px',
    column: [
      {
        label: "ID",
        type: "index",
        prop: "id",
        align: "center",
        width: 50,
        addHide: true,
        editHide: true
      },
      {
        label: "品种名称",
        prop: "name",
        align: "center",
        placeholder: "请输入品种",
        rules: [
          {required: true, message: "请输入品种", trigger: "blur"}
        ],
        span: 12,
        search: true,
      },
      {
        label: "种植园",
        prop: "plantationId",
        span: 12,
        search: false,
        hide: true,
        rules: [
          {required: true, message: "请选择种植园", trigger: "blur"}
        ],
        type: "select",
        dicUrl: "/api/card/plantation/getList",
        dicFormatter: (res: any) => ({list: res.data, label: 'name', value: 'id'}),
      },
      {
        label: "种植园名称",
        prop: "plantationName",
        align: "center",
        width: '150px',
        search: true,
        addHide: true,
        editHide: true
      },
      {
        label: "种植日期",
        prop: "plantDate",
        type: "date",
        align: "center",
        span: 24,
        rules: [
          {required: true, message: "请选择种植日期", trigger: "blur"}
        ],
        addSlot: true,
        editSlot: true
      },
      {
        label: "树龄",
        prop: "treeAge",
        align: "center",
        span: 12,
        rules: [
          {required: true, message: "请输入树龄", trigger: "blur"}
        ],
        placeholder: "请输入树龄",
      },
      {
        label: "状态",
        prop: "status",
        align: "center",
        span: 12,
        placeholder: "请输入状态",
        rules: [
          {required: true, message: "请输入状态", trigger: "blur"}
        ],
        search: true,
      },
      {
        label: "预计产量",
        prop: "expectQty",
        align: "center",
        span: 12,
        placeholder: "请输入预计产量",
        rules: [
          {required: true, message: "请输入预计产量", trigger: "blur"}
        ],
      },
      {
        label: "上季产量",
        prop: "lastSeasonQty",
        align: "center",
        span: 12,
        placeholder: "请输入上季产量",
        rules: [
          {required: true, message: "请输入上季产量", trigger: "blur"}
        ],
      },
      {
        label: "施肥周期",
        prop: "fertilizationCycle",
        align: "center",
        span: 12,
        placeholder: "请输入施肥周期",
        rules: [
          {required: true, message: "请输入施肥周期", trigger: "blur"}
        ],
      },
      {
        label: "浇水周期",
        prop: "wateringCycle",
        align: "center",
        span: 12,
        placeholder: "请输入浇水周期",
        rules: [
          {required: true, message: "请输入浇水周期", trigger: "blur"}
        ],
      },
      {
        label: "备注",
        prop: "remarks",
        align: "center",
        width: '250px',
        maxlength: 200,
        type: "textarea",
      },
      {
        label: "创建时间",
        prop: "addTime",
        align: "center",
        width: '150px',
        addHide: true,
        editHide: true,
      },

    ]
  }

  getList() {
    this.tableLoading = true
    fruitTreeQueryApi(this.queryParam).then(e => {
      this.tableData = e.list
      this.tableTotal = e.total
      this.tableLoading = false
    })
  }

  rowSave(form: IAppletBanner, done: Function, loading: Function) {
    fruitTreeCreateApi(form).then(e => {
      if (e) {
        this.getList()
        this.$message.success("操作成功!")
        done()
      }
    }).finally(() => {
      loading()
    })
  }

  rowEdit(form: IAppletBanner, done: Function, loading: Function) {
    fruitTreeModifyApi(form).then(e => {
      if (e) {
        this.getList()
        this.$message.success("操作成功!")
        done()
      }
    }).finally(() => {
      loading()
    })
  }

  openEdit(row: any, index: number) {
    fruitTreeDetailApi(row.id).then(e => {
      // @ts-ignore
      this.$refs.crudRef.rowEdit(e, index)
    })
  }

  created() {
    this.getList()
  }
}
